<template>
  <div class="" :class="!$vuetify.breakpoint.xsOnly ? 'px-5 py-5' : ''">
    <!-- <watchlist-component :user_id="helper.getUserId()"></watchlist-component> -->
    <WatchListComponent :user_id="helper.getUserId()"> </WatchListComponent>
    <!-- <add-trade-modal></add-trade-modal> -->
  </div>
</template>
<script>
import commonFunctions from "@/common/commonFunctions";
export default {
  name: "WatchlistPage",
  components: {
    // WatchlistComponent: () =>
    //   import(
    //     "@/components/Profile/ProfileTradeDetails/Wacthlist/WatchlistComponent.vue"
    //   ),
    WatchListComponent: () =>
      import(
        "@/components/Profile/ProfileTradeDetails/Wacthlist/NewWatchListComponent.vue"
      ),
  },
  data() {
    return {
      helper: commonFunctions,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>
